import myoshLogo from '../assets/myosh-logo-white-text.svg';

const Sidebar = () => {
  return (
    <aside
      data-testid="login-sidebar"
      className="myl-flex myl-w-full myl-flex-col myl-bg-gradient-to-br myl-from-secondary-1 myl-via-secondary-2 myl-to-secondary-1 sm:myl-max-w-xs"
    >
      <img src={myoshLogo} alt="myosh HSEQ Management Software" className="myl-mx-6 myl-my-4 myl-w-40" />
      <h1 className="myl-text-md myl-mx-6 myl-font-bold myl-text-mono-1 myl-drop-shadow-lg sm:myl-text-lg md:myl-text-xl">
        Safety &amp; Compliance software for every business
      </h1>
    </aside>
  );
};

export default Sidebar;
